// generated from 102 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const churnScoreFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("churn_score_filter"),
  comparison_key: z.enum([
    "5", // 53 (51.96%)
    "3", // 48 (47.06%)
    "1", // 1 (0.98%)
  ]),
  display_name: z.object({
    // undefined: 99 (97.06%), defined 3 (2.94%)
    deleted_model: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 16 (15.69%), defined 86 (84.31%)
  raw_value: z.int().min(0).max(100).optional(),
  value: z.int().min(0).max(100),
  varies_by_app_group: z.literal(false),
});
